import { Section } from '@/components/shared/Content';
import { Box, Flex, font, themedColor, useViewportSize } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import React from 'react';
import styled from 'styled-components';
import { SectionSubtitle } from '../pet/StyledElements';
import { type ImpactSlideProps, ImpactSlider } from './ImpactCards';
import { GBSectionParagraph, GBSectionTitle } from './StyledElements';

const ContentWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const OurImpactSectionTitle = styled(GBSectionTitle)`
  text-align: center !important;
`;

const OurImpactSectionParagraph = styled(GBSectionParagraph)`
  text-align: center;
  font-size: 1.8rem;
  font-weight: 700;
`;

const OurImpactSectionSubtitle = styled(SectionSubtitle)`
  margin: 8px auto 0 auto;
  font-size: 1.8rem;

  ${MEDIA_QUERIES.mobile`
    padding: 0 10px;
  `}
`;

const StyledLinkContainer = styled(Flex)`
  justify-content: center;
  margin: 0 auto;
  ${font('main', { fontSize: '1.6rem', lineHeight: '2.2rem' })};

  ${MEDIA_QUERIES.mobile`
        flex-wrap: wrap;
        gap: 17px 0px;
        padding: 0 20px;
        ${font('main', { fontSize: '1.6rem', lineHeight: '2.2rem' })};
    `}

  ${MEDIA_QUERIES.tabletAndDesktop`
        ${font('main', { fontSize: '1.6rem', lineHeight: '2.24rem' })};
    `}

    a {
    margin: 0px 16px;
    color: ${themedColor('primary')};
  }
`;

const StyledSeparator = styled(Box)`
  background: ${themedColor('veryLightGrey')};
  width: 1px;
  margin: 4px 0px;
`;

type Year = {
  url: string;
  year: string;
};

export interface OurImpact2024Props {
  title: string;
  subtitle: string;
  years: Year[];
  charities: ImpactSlideProps[];
}

function showSeparator(index: number, isMobileViewport: boolean) {
  return index > 0 || (isMobileViewport && index !== 4);
}

export const OurImpact2024: React.FC<OurImpact2024Props> = ({ title, subtitle, years = [], charities = [] }) => {
  const { isMobileViewport } = useViewportSize();
  return (
    <Section py={[40, 70]} darkBackground>
      <ContentWrapper width={1}>
        <Box>
          <OurImpactSectionTitle>{title}</OurImpactSectionTitle>
          <OurImpactSectionSubtitle>{subtitle}</OurImpactSectionSubtitle>
        </Box>

        <ImpactSlider charities={charities} />

        <Box mb={16}>
          <OurImpactSectionParagraph>Previous years</OurImpactSectionParagraph>
        </Box>
        <StyledLinkContainer>
          {years.map(({ year, url }, index) => (
            <React.Fragment key={year}>
              {showSeparator(index, isMobileViewport) && <StyledSeparator />}
              <a href={url} target="_blank" rel="noreferrer">
                {year}
              </a>
            </React.Fragment>
          ))}
        </StyledLinkContainer>
      </ContentWrapper>
    </Section>
  );
};
